import React from 'react'

const AnalyticsScreen = () => {
    return (
        <div>AnalyticsScreen</div>
    )
}

export default AnalyticsScreen